import {mapFields} from 'vuex-map-fields'
export default{
    computed:{
        ...mapFields([
            'selectedReport',
            'selectedResult'
            

        ]),
    },
    methods:{
        getCurrentParamValue(id){
            var name = null
            //look at selected scheduled report params to get the value
            this.selectedReport.Parameters.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let param=arr[index]
                if(param.ParameterID==id){

                    name= param.Name

                }
            }
            return name
        }

    }
}